export default __webpack_public_path__ + "static/media/hitpay.cebef49d.png";